

import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { logout } from "../../user/api/actions";
import { updateWorkOrder } from "../../workOrders/api/actions";
import { useParams } from "react-router-dom";
import { Box, Divider, TextField, MenuItem, Button, Typography } from '@mui/material';
import { getAllUnitTypes } from "modules/apl/api/actions";
import { get as getPropertyManager } from "modules/propertyManager/api/actions";
import Autocomplete from '@mui/material/Autocomplete';
import { getByUuid as getPropertyByUuid } from "modules/property/api/actions";
import { getAllCustomerTypes, getAllAccountStatusCodes } from "modules/apl/api/actions";
import { setSnackbar } from "modules/snackbar/api/snackbar";

function UnitForm(props) {
  const dispatch = useDispatch();
  const params = useParams();
  let propertyManagers = [];
  const [addressTypes, setAddressTypes] = useState(["APT", "STE", "UNIT"])
  const [startingLetter, setStartingLetter] = useState("A");
  const [isLoading, setIsLoading] = useState(true);
  const [property, setProperty] = useState({ name: "", owner: { name: "" }, developer: { name: "" } });
  const [state, setState] = useState({
    unitType: "",
    address1: "",
    city: "",
    state: "",
    zip: "",
    addressType: "",
    numberOfUnits: "10",
    startUnit: "A",
    startERT: 100,
    startMeterNum: 100,
    propertyManager: "",
    ownerId: "",
    developerId: "",
    owner: "",
    developer: "",
    propertyManagerName: "",
    commonAccount: 0,
    propertyId: "",
    sqFt: "0",
    bed: "0",
    batch: "0",
    buildingNumber: "",
    heatingType: "Electric",
    moveInDate: "",
    bedrooms: "",
    baths: ""

  });
  let propertyUuid = params.propertyUuid;

  const [pm, setPM] = useState(props.propertyManagers.data.propertyManagersList.items || [{ id: "", label: "" }])
  const [fullAddress, setFullAddress] = useState("");
  const handleChange = (evt) => {
    let value = evt.target.value;
    if (evt.target.name == "isActive") value = evt.target.checked;

    setState({
      ...state,
      [evt.target.name]: value,
    });

    setFullAddress(`${state.address1} ${state.addressType} ${state.startUnit} ${state.city}, ${state.state} ${state.zip}`)

  };

  const nextLetter = (l) => {
    if (l < 90) {
      return String.fromCharCode(l + 1);
    }
    else {
      return startingLetter;
    }
  }

  const same = (str, char) => {
    var i = str.length;
    while (i--) {
      if (str[i] !== char) {
        return false;
      }
    }
    return true;
  }


  const nextCharCustom = (c) => {
    var u = c.toUpperCase();
    if (same(u, 'Z')) {
      var txt = '';
      var i = u.length;
      while (i--) {
        txt += startingLetter;
      }
      return (txt + startingLetter);
    } else {
      var p = "";
      var q = "";
      if (u.length > 1) {
        p = u.substring(0, u.length - 1);
        q = String.fromCharCode(p.slice(-1).charCodeAt(0));
      }
      var l = u.slice(-1).charCodeAt(0);
      var z = nextLetter(l);
      if (z === startingLetter) {
        return p.slice(0, -1) + nextLetter(q.slice(-1).charCodeAt(0)) + z;
      } else {
        return p + z;
      }
    }
  }




  const generateUnitDataTable = () => {

    if (!formRef.current.reportValidity())
      return;


    let dataTable = [];
    let unitRecord = {};
    let unitIncrement = state.startUnit.toString();
    let meterNumberIncrement = state.startMeterNum;
    let ertNumberIncrement = state.startERT;


    let isChar = false;

    if (!isNaN(state.startUnit)) {
      unitIncrement = Number(state.startUnit);
    } else {
      isChar = true;
      unitIncrement = state.startUnit;
      setStartingLetter(state.startUnit);
    }


    for (let x = 0; x < Number(state.numberOfUnits); x++) {

      //Get new Unit

      unitRecord = {};
      unitRecord = {
        ...state,
        address2: state.startUnit ? `${state.addressType} ${unitIncrement}` : "",
        meterNumber: "",
        ertNumber: "",
        commonAccount: false
      }
      delete unitRecord.addressType //Not needed in
      dataTable.push(unitRecord);
      if (isChar) {
        // Set last char to incremented Char
        unitIncrement = nextCharCustom(unitIncrement);
      }
      else {
        unitIncrement++;
      }

      meterNumberIncrement++;
      ertNumberIncrement++;
    }
    let selectedPM = props.propertyManagers.data.propertyManagersList.items.find(v => v.id == state.propertyManager)
    let pmCustomerType = selectedPM.developerId ? props.apl.genericTypes.customerType.data.find(v => v.description == "Developer") :  props.apl.genericTypes.customerType.data.find(v => v.description == "Management Co")
    let activeAccountStatus = props.apl.genericTypes.accountStatus.data.find(v => v.description == "Active")
    props.onGenerateDataTable(dataTable, selectedPM, pmCustomerType, activeAccountStatus)
    dispatch(setSnackbar(true, "success", "New data generated."))
  }

  const nextChar = (c) => {
    c = String(c)
    return String.fromCharCode(c.charCodeAt() + 1);
  }


  useEffect(() => {
    async function fetchData() {
      await props.getAllUnitTypes();
      await props.getAllCustomerTypes()
      await props.getPropertyByUuid(propertyUuid);
      await props.getAllAccountStatusCodes();
      if (props.propertyManagers.data.propertyManagersList.items.length <= 0) {
        await props.getPropertyManager();
        propertyManagers = props.propertyManagers.data.propertyManagersList.items.map(pm => {
          return { label: `${pm.name}`, id: pm.id }
        })

        setPM(propertyManagers);
        setProperty(props.properties.data.property)
        setState({
          ...state,
          address1: props.properties.data.property.address,
          state: props.properties.data.property.state,
          city: props.properties.data.property.city,
          zip: props.properties.data.property.zip,
          propertyManager: props.properties.data.property.propertyManagerId,
          propertyId: props.properties.data.property.id,
          developerId: props.properties.data.property.developerId,
          ownerId: props.properties.data.property.ownerId,
          developer: props.properties.data.property.developer.name,
          owner: props.properties.data.property.owner.name,
          propertyManagerName: props.properties.data.property.propertyManager.name,
        })
        setIsLoading(false);

      }
    }
    fetchData();
  }, []);

  const formRef = React.useRef();


  return (
    <Box sx={{ width: '100%' }}>
      {!isLoading && (
        <form ref={formRef}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, width: '100%' }}>
            {/* Property Info Section */}
            <Box sx={{ 
              p: 2, 
              bgcolor: 'background.paper',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider'
            }}>
              <Typography variant="h6" gutterBottom>Property Information</Typography>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                <strong>Property:</strong> {property.name || ""}
              </Typography>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                <strong>Owner:</strong> {property.owner.name || ""}
              </Typography>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                <strong>Developer:</strong> {property.developer.name || ""}
              </Typography>
              {fullAddress && (
                <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                  <strong>Proposed Address:</strong> {fullAddress}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
              <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                  {/* Basic Information */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>Basic Information</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                      <TextField
                        fullWidth
                        required
                        type="date"
                        size="small"
                        label="Move In Date"
                        InputLabelProps={{ shrink: true }}
                        value={state.moveInDate}
                        onChange={handleChange}
                        name="moveInDate"
                      />
                      <TextField
                        fullWidth
                        required
                        select
                        size="small"
                        label="Unit Type"
                        name="unitType"
                        value={state.unitType}
                        onChange={handleChange}>
                        {props.apl.genericTypes.unitType.data.map(option => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.description}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>

                    {/* Unit Details */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2 }}>
                      <TextField
                        fullWidth
                        required
                        size="small"
                        label="SQ Footage"
                        type="number"
                        value={state.sqFt}
                        onChange={handleChange}
                        name="sqFt"
                      />
                      <TextField
                        fullWidth
                        required
                        size="small"
                        label="Bedrooms"
                        type="number"
                        value={state.bedrooms}
                        onChange={handleChange}
                        name="bedrooms"
                      />
                      <TextField
                        fullWidth
                        required
                        size="small"
                        label="Baths"
                        type="number"
                        value={state.baths}
                        onChange={handleChange}
                        name="baths"
                      />
                    </Box>

                    {/* Address Information */}
                    <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>Address Information</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                        <TextField
                          fullWidth
                          required
                          size="small"
                          label="Address 1"
                          value={state.address1}
                          onChange={handleChange}
                          name="address1"
                        />
                        <TextField
                          fullWidth
                          required
                          size="small"
                          label="Building Number"
                          value={state.buildingNumber}
                          onChange={handleChange}
                          name="buildingNumber"
                        />
                      </Box>
                      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2 }}>
                        <TextField
                          fullWidth
                          required
                          size="small"
                          label="City"
                          value={state.city}
                          onChange={handleChange}
                          name="city"
                        />
                        <TextField
                          fullWidth
                          required
                          size="small"
                          label="State"
                          value={state.state}
                          onChange={handleChange}
                          name="state"
                        />
                        <TextField
                          fullWidth
                          required
                          size="small"
                          label="Zip"
                          value={state.zip}
                          onChange={handleChange}
                          name="zip"
                        />
                      </Box>
                    </Box>

                    {/* Additional Details */}
                    <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>Additional Details</Typography>
                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                      <TextField
                        fullWidth
                        required
                        size="small"
                        label="Heating Type"
                        value={state.heatingType}
                        onChange={handleChange}
                        name="heatingType"
                      />
                      <TextField
                        fullWidth
                        size="small"
                        select
                        label="Address Type"
                        name="addressType"
                        value={state.addressType}
                        onChange={handleChange}
                        helperText="APT, UNIT, STE, etc.">
                        {addressTypes.map(type => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Box>

                    {props.properties.data.property.propertyManagerId && pm.length > 0 && (
                      <Autocomplete
                        disablePortal
                        required
                        size="small"
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        defaultValue={pm.find(v => v.id == props.properties.data.property.propertyManagerId)}
                        name="propertyManager"
                        onChange={(event, value) => setState({ ...state, propertyManagerName: value.label, propertyManager: value?.id || "" })}
                        options={pm}
                        renderInput={(params) => (
                          <TextField {...params}
                            size="small"
                            label="Property Manager" 
                          />
                        )}
                      />
                    )}
                  </Box>
                </Box>

                {/* Unit Generation Settings */}
                <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 12px)' } }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>Unit Generation Settings</Typography>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      size="small"
                      label="Number of Units to Create"
                      value={state.numberOfUnits}
                      onChange={handleChange}
                      name="numberOfUnits"
                    />

                    <TextField
                      fullWidth
                      size="small"
                      label="Start Unit Identifier"
                      helperText="Enter a number (100, 101...) or letter (A, B, C...)"
                      value={state.startUnit}
                      onChange={handleChange}
                      name="startUnit"
                    />

                    <Button 
                      onClick={generateUnitDataTable} 
                      variant="contained" 
                      color="primary"
                      sx={{ mt: 2 }}
                    >
                      Generate Units
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </form>
        )}
      </Box>
    );
}
// Component Properties
UnitForm.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  getAllUnitTypes: PropTypes.func.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  getPropertyManager: PropTypes.func.isRequired,
  property: PropTypes.object.isRequired,
  getPropertyByUuid: PropTypes.object.isRequired,
  getAllCustomerTypes: PropTypes.func.isRequired,
  getAllAccountStatusCodes: PropTypes.func.isRequired
};

// Component State
function UnitFormState(state) {
  return {
    user: state.user,
    apl: state.apl,
    propertyManagers: state.propertyManagers,
    properties: state.properties
  };
}

export default connect(UnitFormState, { logout, getAllUnitTypes, getPropertyManager, getPropertyByUuid, getAllCustomerTypes, getAllAccountStatusCodes })(
  UnitForm
);
